export default __webpack_public_path__ + "static/media/ZM.9dc3c659.ico";